module.exports = import("https://buildyour.cnhind.com/assets/remoteEntry.js");